import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchMe, logout as apiLogout } from "../lib/api";
import { walletRefresh, disconnectWalletConnect } from "../lib/wallet";

const AuthCtx = createContext({
  user: null,
  loading: true,
  isPro: false,
  refresh: () => {},
  refreshPro: async () => {},
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await fetchMe();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshPro = useCallback(async () => {
    try {
      const { user: u } = await walletRefresh();
      setUser(u);
      return u;
    } catch (e) {
      // 401 / 400 means no wallet linked — just bail silently
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signOut = useCallback(async () => {
    try {
      await apiLogout();
      await disconnectWalletConnect();
    } finally {
      setUser(null);
    }
  }, []);

  const isPro = !!user?.pro_active;

  return (
    <AuthCtx.Provider value={{ user, loading, isPro, refresh, refreshPro, signOut }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
